import { ERROR_MESSSAGES } from '@constants/common.constants';
import { analytics, logEvent } from '@/FireBase';
import { EventNameString } from 'firebase/analytics';
import { DateTime, Interval } from 'luxon';
import { formatDate } from './date-time.helper';
import { DATE_FORMAT } from '@constants/date-time.constants';

export enum FirebaseCustomEvents {
	ENABLE_PUSH_NOTIF = 'enable_push_notif',
	SELECT_PAST_7DAY_TXN = 'select_past_7day_txn',
	SELECT_MONTHTODATE_TXN = 'select_monthtodate_txn',
	SELECT_DATE_SEARCH = 'select_date_search',
}

interface IEventParams {
	[key: string]: unknown;
}

const logFirebaseEvent = (eventName: FirebaseCustomEvents | string, eventParams: IEventParams) => {
	if (!analytics) {
		console.warn(ERROR_MESSSAGES.FIREBASE_ANALYTICS_NOT_INITIALIZED);
		return;
	}
	logEvent(analytics, eventName, eventParams);
};

export const logFirebaseSelectPast7DayTxn = () => {
	logFirebaseEvent(FirebaseCustomEvents.SELECT_PAST_7DAY_TXN, {});
};

export const logFirebaseSelectMonthToDateTxn = () => {
	logFirebaseEvent(FirebaseCustomEvents.SELECT_MONTHTODATE_TXN, {});
};

export const logFirebaseSelectDateSearch = (startDate: Date, endDate: Date) => {
	const start = DateTime.fromJSDate(startDate);
	const end = DateTime.fromJSDate(endDate);
	const duration = Math.round((start.until(end) as Interval).toDuration(['days']).toObject().days as number);
	const data = {
		start_date: formatDate(start.toJSDate(), DATE_FORMAT),
		end_date: formatDate(end.toJSDate(), DATE_FORMAT),
		duration: duration + ' day' + (duration === 1 ? '' : 's'),
	};
	logFirebaseEvent(FirebaseCustomEvents.SELECT_DATE_SEARCH, data);
};

export const logFirebaseEnablePushNotif = (pushNotifEventKey: { outlet: string, brand: string }) => {
	logFirebaseEvent(FirebaseCustomEvents.ENABLE_PUSH_NOTIF, pushNotifEventKey);
};

export const logFirebaseLogin = (eventParams: { brand: string; outlet: string }) => {
	const eventName: EventNameString = 'login';
	logFirebaseEvent(eventName, eventParams);
};
